<template>
  <el-dialog title="Edit Information" :width="dialogWidth" :visible="visible" :close-on-click-modal="false" @close="visible = false">
    <el-form ref="form" :model="ruleForm" :rules="rules" label-position="top" v-loading="form_loading" label-width="150px">
      <el-form-item label="First Name" prop="firstName">
        <el-input v-model="ruleForm.firstName" placeholder="First Name"></el-input>
      </el-form-item>
      <el-form-item label="Last Name" prop="lastName">
        <el-input v-model="ruleForm.lastName" placeholder="Last Name"></el-input>
      </el-form-item>
      <el-form-item label="Chart No" prop="chartNo">
        <el-input v-model="ruleForm.chartNo" placeholder="Chart No"></el-input>
      </el-form-item>
      <el-form-item label="Comments">
        <el-input v-model="ruleForm.comments" placeholder="Comments"></el-input>
      </el-form-item>
      <el-form-item style="display: flex;justify-content: center;">
        <el-button type="primary" style="background-color: #034844;border-color:#034844;" @click="submitForm">Save</el-button>
        <el-button @click="visible = false">Cancel</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import Vue from 'vue';
import moment from 'moment/moment';
import { postAction,getAction } from '@/network/manage';
export default {
  name: 'Edit',
  components: {},
  data() {
    return {
      dialogWidth:'600px',
      id: '',
      visible:false,
      ruleForm:{},
      newImage:'',
      brightness:50,
      saturate:50,
      contrast:50,
      rules: {
        firstName: [{required: true, message: 'First Name is required',trigger: 'blur'}],
        lastName: [{required: true, message: 'Last Name is required',trigger: 'blur'}],
        chartNo: [{required: true, message: 'Chart No is required',trigger: 'blur'}]
      },
      form_loading: false,
    }
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        this.setDialogWidth()
      })()
    }
  },
  computed: {

  },
  created() {
    this.setDialogWidth()
  },
  methods: {
    moment,
    init(id,newImageId,brightness,saturate,contrast) {
      this.visible = true
      this.newImage = newImageId
      this.brightness = brightness
      this.saturate = saturate
      this.contrast = contrast
      this.form_loading = true
      getAction('/admin/caseHistory/queryById?id='+id).then((res) => {
        if(res.success){
          this.ruleForm = res.result
        }else{
          this.$message.error(res.message)
        }
      }).catch((err) => {
        this.$message.error(err.message)
      }).finally((res) => {
        this.form_loading = false
      });
    },
    submitForm() {
      const that = this
      this.$refs.form.validate((valid) => {
        if (valid) {
          that.form_loading = true
          const params = {
            id:that.ruleForm.id,
            chartNo:that.ruleForm.chartNo,
            firstName:that.ruleForm.firstName,
            lastName:that.ruleForm.lastName,
            comments:that.ruleForm.comments,
            newImageId:that.newImage,
            brightness:that.brightness,
            saturate:that.saturate,
            contrast:that.contrast
          }
          postAction('/admin/caseHistory/edit',params).then((res) => {
            if(res.success){
              that.$message({
                message: 'edit success!',
                type: 'success'
              });
              that.visible = false
              that.$router.push('/caseHistory')
            }else{
              that.$message.error(res.message)
            }
          }).catch((err) => {
            that.$message.error(err.message)
          }).finally((res) => {
            that.form_loading = false
          });
        }
      });
    },
    setDialogWidth() {
      var val = document.body.clientWidth
      const def = 600 // default width
      if (val < def) {
        this.dialogWidth = '100%'
      } else {
        this.dialogWidth = def + 'px'
      }
    }
  }
}
</script>

<style scoped>
  .form{display: grid;grid-template-columns:1fr 1fr;}
  .form .flex{display: flex;justify-content: space-between;min-height:60px;align-items: center;font-size: 14px;}
  .border{border-bottom: 1px solid #EDF2F7;}
  .left{border-right: 1px solid #EDF2F7;padding-right:30px;margin-right: 30px;}
  .form a{font-size: 18px;font-weight: bold;color: #5856D6;width: 100%;text-align: center;}
  >>>.el-form-item__label{line-height: 1;}
  >>>.el-dialog__header{border-bottom:1px solid #dddddd;padding:15px 20px;}
  >>>.el-dialog__body{padding:20px;}
  h1{font-size: 18px;margin:20px 0;}
  b{font-size: 18px;}
  p{font-size: 14px;}
  .label{display:flex;}
  .label span{margin:0 10px 10px 0;}
  @media (max-width: 768px) {
     .form{display: grid;grid-template-columns:1fr;}
     .left{border-right: 0px solid #EDF2F7;padding-right:0;margin-right: 0;}
  }
</style>
